import type { ReactNode } from "react";
import { TellescopeQueryProvider, useAuth } from "@tellescope/tanstack-query";

interface AdminQueryProviderProps {
  children: ReactNode;
}

export function AdminQueryProvider({ children }: AdminQueryProviderProps) {
  const { session } = useAuth();

  return <TellescopeQueryProvider session={session}>{children}</TellescopeQueryProvider>;
}
